// extracted by mini-css-extract-plugin
export var arbiterSwatch = "_23-3";
export var dialog = "_23-0";
export var divClassnameSwatch = "_23-8";
export var flexSwatch = "_23-4";
export var header = "_23-1";
export var styleAttributeSwatch = "_23-7";
export var swatch = "_23-2";
export var textHeaderSwatch = "_23-5";
export var webSwatch = "_23-6";